
export default {
  data() {
    return {
      title: "Terms of Service | Bikeflights.com",
    };
  },
  head() {
    return {
      title: this.title,
    };
  },
};
